import NavigationController from "../controller/NavigationController";
import Utils from "./Utils";

export default class Analytics {
    constructor() {
        this.GA3 = 3; //OLDSCHOOL
        this.GA4 = 4;
    }
    sendEventUpdate(data, issue_id, spread_id) {
        try {
            window.frontend.bounceRateTimer && clearTimeout(window.frontend.bounceRateTimer);
            let analytics = window.maglrAnalyticsSettings ?? window.interface_settings?.settings?.analytics;

            const ga4User = analytics?.ga_code?.indexOf("G-") === 0;

            const ga4Enabled = ga4User;
            const ga3Enabled = !ga4User;

            if (data.action === "Internal") {
                const to = data.label.split("::")[0].trim().split("|");
                data.label = window.frontend.dataHelper.getSpreadById(to[0], to[1])?.url;
            }
            if (analytics?.ga_global === 1) {
                window.frontend.pirsch.sendEventUpdate(data, issue_id, spread_id);
            }

            if (issue_id && spread_id) {
                data.page =
                    window.frontend.dataHelper.getSpreadById(issue_id, spread_id)?.url ||
                    NavigationController.getPathname().join("/");
            }

            if (window.gtag !== undefined) {
                //OLDSCHOOL OLD WAY ( based on given data )
                if (data.dataGA3 === undefined && data.dataGA4 === undefined) {
                    let event_data;
                    switch (data.hitType) {
                        case "page_view":
                            data.eventAction = "page_view";
                            event_data = {
                                page_title: document.title,
                                page_location: location.href,
                                page_path: data.page,
                            };
                            break;
                        case "event":
                            event_data = {
                                event_category: data.eventCategory || data.type,
                                event_label: data.eventLabel || data.label,
                                value: data.eventValue || data.value,
                            };
                            break;
                    }

                    if (!ga4Enabled) {
                        const GA3 = JSON.parse(JSON.stringify(event_data));
                        const GA4 = JSON.parse(JSON.stringify(event_data));

                        GA4.send_to = "GA4";
                        this.changeConfig(GA4);
                        window.gtag("event", data.eventAction || data.action, GA4);

                        GA3.send_to = "GA3";
                        this.addDimensionData(GA3, issue_id, spread_id);
                        window.gtag("event", data.eventAction || data.action, GA3);
                    }
                }

                if (data.dataGA3 !== undefined && ga3Enabled) {
                    let dimensions = this.addDimensionData({}, issue_id, spread_id);
                    window.gtag(
                        "event",
                        data.dataGA3.action,
                        Object.assign(
                            {
                                event_category: data.dataGA3.type,
                                event_label: data.dataGA3.label,
                                value: data.dataGA3.value,
                                send_to: "GA3",
                            },
                            dimensions,
                        ),
                    );
                }

                if (data.dataGA4 && ga4Enabled) {
                    this.addData(data.dataGA4.data);
                    this.changeConfig(data.dataGA4.data);
                    data.dataGA4.data.send_to = "GA4";
                    window.gtag("event", data.dataGA4.type, data.dataGA4.data);
                }
            }
        } catch (e) {
            console.warn("AnalyticsError: ", e);
        }

        this.sendGTMEventUpdate(data, issue_id, spread_id);
    }

    /**
     * Send Event updates like clicks, starts video's etc
     *
     * @param {Object} data
     * @param {Number} issue_id
     * @param {Number} spread_id
     * @private
     */
    sendGTMEventUpdate(data, issue_id = null, spread_id = null) {
        this.setGTMData(this.createGTMAdditionals(data, issue_id, spread_id));
    }

    setGTMData(data) {
        try {
            window.dataLayer && window.dataLayer.push(data);
        } catch (e) {
            console.warn("GTM Error: ", e);
        }
    }

    createGTMAdditionals(data, issue_id = null, spread_id = null) {
        const gtmData = {};
        if (data?.hitType === "page_view") {
            if (!window._maglrPageViewRegistered) {
                gtmData.event = "maglrPageView";
                window._maglrPageViewRegistered = true;
            } else {
                gtmData.event = "maglrVirtualPageView";
            }
        } else if (data?.hitType === "event") {
            gtmData.event = "maglrUserEvent";
            if (data?.maglrPageEvent) {
                gtmData.event = "maglrPageEvent";
            }
            if (data?.maglrInterfaceEvent) {
                gtmData.event = "maglrInterfaceEvent";
            }

            if (data?.eventCategory || data?.dataGA3?.type) {
                gtmData.maglrCategory = data.eventCategory || data?.dataGA3?.type;
            }
            if (data?.eventAction || data?.dataGA3?.action) {
                data.action = data?.eventAction || data?.dataGA3?.action;
                gtmData.maglrAction = data.eventAction || data?.dataGA3?.action;
            }
            if (data?.eventLabel || data?.dataGA3?.label) {
                data.label = data?.eventLabel || data?.dataGA3?.label;
                if (data.action === "Internal") {
                    var to = data.label.split("::")[0].trim().split("|");
                    data.label = window.frontend.dataHelper.getSpreadById(to[0], to[1])?.url;
                }
                gtmData.maglrLabel = data.label;
            }
            if (data?.eventValue || data?.dataGA3?.value) {
                gtmData.maglrValue = data.eventValue || data.dataGA3.value;
            }
        }

        //Add the Additional data when we have it
        issue_id = issue_id || window.frontend.getCurrentIssueId();
        spread_id = spread_id || window.frontend.getCurrentSpreadId();

        if (issue_id && spread_id) {
            const spread = window.frontend.dataHelper.getSpreadById(issue_id, spread_id);
            const issue = window.frontend.dataHelper.getIssueByIssueId(issue_id);
            let url = window.location.href;
            if (issue_id !== window.frontend.getCurrentIssueId()) {
                url = `${window.location.origin}/${spread.url}`;
            }
            gtmData["maglrIssueID"] = issue_id;
            gtmData["maglrSpreadID"] = spread_id;
            gtmData["maglrLanguage"] = window.frontend.getLanguage();

            gtmData["MaglrCookieConsented"] = window.MaglrCookieConsented || false;

            gtmData["maglrPageType"] = data.dimension4 || "publication"; //  "singelpage, embed, publication, proposal, personalised, offline, zip, ipad"
            let status = window.frontend.getSpreadStatus(spread_id);
            status && (gtmData["maglrPageStatus"] = status);
            spread.reference_tag && (gtmData["maglrReferenceTag"] = spread.reference_tag);
            gtmData["maglrPagePath"] = spread.url; // spread pathname
            gtmData["maglrPageURL"] = url; // full page url
            gtmData["maglrPageTitle"] = spread.spread_title; // spread title
            gtmData["maglrProjectTitle"] = issue.issue_title; // issue title
            if (data?.dataGA4?.data?.element_id) {
                gtmData["maglrElementName"] = data?.dataGA4?.data?.element_name;
                gtmData["maglrElementID"] = data?.dataGA4?.data?.element_id;
            }
        }
        return gtmData;
    }

    addData(data) {
        let issue = window.frontend.dataHelper.getIssueByIssueId(+data.issue_id);
        let spread = window.frontend.dataHelper.getSpreadById(+data.issue_id, +data.spread_id);
        for (var name in data) {
            switch (name) {
                case "element_name":
                    data["maglrElementName"] = data.element_name;
                    break;
                case "element_id":
                    data["maglrElementID"] = data.element_id;
                    break;
                case "issue_title":
                    data[name] = issue.issue_title;
                    break;
                case "spread_title":
                case "page_title":
                    data[name] = spread.spread_title;
                    break;
            }
        }
        return data;
    }
    changeConfig(config) {
        config.maglr_client_id = self.client_id;
        config.issue_type = "publication";

        if (self.frontend._homepage) {
            let { category } = NavigationController.getGetParams();
            if (category) {
                config.category = category;
            }
        } else {
            if (window.frontend.getCurrentIssueId()) {
                config.issue_id = window.frontend.getCurrentIssueId();
            }

            if (window.frontend.getCurrentSpreadId()) {
                config.spread_id = window.frontend.getCurrentSpreadId();
            }

            // if(self.frontend._user_id){
            //     config.maglr_user_id = self.frontend._user_id;
            // }
        }

        if (window.mail_hash) {
            config.issue_type = "personalised";
            config.mail_hash = window.mail_hash; // pageHash (code embed, of code bij personalisatiemagazine)
            // config.maglr_user_id = `${window.replaceables.global.user_id}` // User_id of user that created the mailing
        } else if (window.embedHash) {
            config.issue_type = "embed";
            config.embed_hash = window.embedHash; // pageHash (code embed, of code bij personalisatiemagazine)
        } else if (window.exportType === "ipad") {
            config.issue_type = "presenter";
        }

        return config;
    }

    stripDimensionData(data) {
        let mutatedCopy = JSON.parse(JSON.stringify(data));
        delete mutatedCopy.dimension1;
        delete mutatedCopy.dimension2;
        delete mutatedCopy.dimension3;
        delete mutatedCopy.dimension4;
        delete mutatedCopy.dimension5;
        delete mutatedCopy.dimension6;
        return mutatedCopy;
    }

    createUserEvent(data) {
        let page;
        if (Utils.hasHashBinding()) {
            page = window.frontend.dataHelper.getSpreadById(window.issue_id, window.spread_id)?.url || data.page;
        } else {
            page = NavigationController.getPathname().join("/");
        }
        return {
            hitType: "event", //
            page: page,
            eventCategory: data[0], //example VIDEO, URL_CHANGED
            eventAction: data[1], //example START, STOP, OPENED
            eventLabel: data[2] || 0, //example https://youtu.be/w?-
            eventValue: data[3] || 0, //not really used(mostly issue_id)
            maglrInterfaceEvent: true,
        };
    }

    addDimensionData(data = {}, issue_id = null, spread_id = null) {
        if (!data.dimension1) {
            data.dimension1 = `${self.client_id}`;
        }
        if (!data.dimension4) {
            data.dimension4 = "publication"; // pageType (singlepage, embed, publication, proposal, personalised, offline, zip)
        }

        if (self.frontend._homepage) {
            let { category } = NavigationController.getGetParams();
            if (category) {
                data.dimension2 = "Category";
                data.dimension3 = category; // category_id
            }
        } else {
            if (!data.dimension2 && self.frontend._issue_id) {
                data.dimension2 = `${issue_id || self.frontend._issue_id}`; // issue_id
            }

            if (!data.dimension3 && self.frontend._spread_id) {
                data.dimension3 = `${spread_id || self.frontend._spread_id}`; // spread_id
            }

            // if(!data.dimension6 && self.frontend._user_id){
            //     data.dimension6 = `${self.frontend._user_id}` // User_id of user that created the issue
            // }
        }

        if (window.mail_hash) {
            data.dimension4 = "personalised";
            data.dimension5 = window.mail_hash; // pageHash (code embed, of code bij personalisatiemagazine)
            data.dimension6 = `${window.replaceables.global.user_id}`; // User_id of user that created the mailing
        } else if (window.embedHash) {
            data.dimension4 = "embed";
            data.dimension5 = window.embedHash; // pageHash (code embed, of code bij personalisatiemagazine)
        } else if (window.exportType === "ipad") {
            data.dimension4 = "presenter";
        }

        return data;
    }
    /**
     * Bind delegated click tracking on the document.
     *
     * Native replacement for the previous jQuery `$(document).on("click.ga", ...)`
     * delegated handlers (kept as two independent checks, not else-if, because
     * jQuery ran both delegated handlers for every click and either or both
     * could match). `[data-ga-category][data-ga-action]` intentionally reads
     * `event.target.dataset` rather than the matched ancestor's dataset,
     * mirroring jQuery's delegated handler which received the raw click target,
     * not the element that matched the selector.
     */
    bindUserEventsButtonClick() {
        document.addEventListener("click", (event) => {
            const shortTarget = event.target.closest("[data-ga-short]");
            if (shortTarget) {
                let element_data = shortTarget.dataset.gaShort.split("|");
                if (element_data && element_data.length > 1) {
                    this.sendEventUpdate(this.createUserEvent(element_data));
                } else {
                    console.warn("Missing Analytics data: ", element_data);
                }
            }

            if (event.target.closest("[data-ga-category][data-ga-action]")) {
                const element_data = event.target.dataset;
                this.sendEventUpdate(
                    this.createUserEvent([
                        element_data.gaCategory,
                        element_data.gaAction,
                        element_data.gaLabel,
                        element_data.gaValue,
                    ]),
                );
            }
        });
    }
}
